export default __webpack_public_path__ + "static/media/MP0006.e5902701.jpg";